import{inversifyContainer as o,INVERSIFY_TYPES as e}from"../inversify/index.js";const i=()=>o.get(e.cookies);export{i as useCookies};
